export interface SetStateOptions {
    save?: boolean;
}

export interface GetStateOptions {
    raw?: boolean;
}

export const defaultStateOptions: SetStateOptions = {
    save: true,
};
